import React,{useState} from 'react'
import "./Mainpage.css";
import Mealcars from './Mealcars';

const Mainpage=()=> {

  const[data,setData] =useState();
  const[search,setSearch] = useState(" ");
  const[msg,setMsg] = useState("")

  const handleInput = (event)=>{
    setSearch(event.target.value)
  }

  const myFun = async()=>{

    if(search == " "){
      setMsg("please enter a value")
    }
    else{
      const get = await fetch(`https://www.themealdb.com/api/json/v1/1/search.php?s=${search}`);
    const jsonData = await get.json();
    //console.log(jsonData.meals);
    setData(jsonData.meals)
    setMsg("")
    }
    
  }

  console.log(data);

  return (
    <>
    <h1>FOOD RECIPE APP</h1>
    <div className='Cointainer'>
      <div className='searchbar'></div>
      <input type='text' placeholder='Enter the Dish Name' onChange={handleInput}></input>
      <button onClick={myFun}>Search</button>
     
    </div>
<h4 className='message'>{msg}</h4>
    <div>
      <Mealcars  detail={data}></Mealcars>
    </div>
    </>
  )
}
 
export default Mainpage
